window.AMSRequestRightToWorkForm = function (scope, formData, brandServices) {
    var form = this;
    var formName = "ams-request-right-to-work-form";
    var _protected = BaseForm.call(form, formName, scope);
    var _emitter = JarEventEmitter.call(form);

    form.resend = formData.resend;
    form.isAMSCardSendClicked = formData.isAMSCardSendClicked;

    form.data = {};
    var defaultMessage = '';

    const setDefaultMessage = (countryCode) => {
        defaultMessage = $filter("translate")("Dear") + ' ' + formData.candidate.name + ', \n\n';
        if (countryCode === RightToWorkAPI.COUNTRY_TYPES.ROI) {
            defaultMessage += $filter("translate")("Please provide identity documents that prove you are eligible to work in the Republic of Ireland");
        } else if (countryCode === RightToWorkAPI.COUNTRY_TYPES.UK) {
            defaultMessage += $filter("translate")("Please provide identity documents that prove you are eligible to work in the UK");
        } else {
            defaultMessage += $filter("translate")("Please provide identity documents that prove you are eligible to work");
        }

        defaultMessage += '.\n\n' + $filter("translate")("Please ensure to bring the physical copy with you for verification") + '.'

        if (!form.resend || !form.data.message) {
            form.data.message = defaultMessage;
        }
    };

    var getCountryType = function () {
        var defer = $q.defer();
        form.loading = true;
        brandServices.check(brandServices.SERVICES.RIGHT_TO_WORK, formData.brandId)
            .then(function (isRightToWorkEnabled) {
                if (isRightToWorkEnabled) {
                    RightToWorkAPI.getRightToWorkSettings(formData.documentData.brand_id)
                        .then(function (res) {
                            setDefaultMessage(res['country_type']);
                            defer.resolve();
                        })
                        .catch(function (err) {
                            setDefaultMessage();
                            console.error(err);
                            defer.reject();
                        })
                        .finally(function () {
                            form.loading = false;
                        });
                } else {
                    EVerifyAPI.getBrandServicesSettings(formData.brandId, brandServices.SERVICES.TRUST_ID_FULL).then((res) => {
                        setDefaultMessage(res.settings.country_code);
                        form.loading = false;
                        defer.resolve();
                    }).catch((err) => {
                        setDefaultMessage();
                        console.error(err);
                        defer.reject();
                    })
                    .finally(() => {
                        form.loading = false;
                    });
                }
            })
            .catch(function (err) {
                setDefaultMessage();
                console.error(err);
                defer.reject();
            });
        return defer.promise;
    };

    getCountryType()
        .finally(function () {
            scope.$digest();
        });


    form.load = function () {
        var defer = $q.defer();
        form.loading = true;

        if (formData.document) {
            form.document = [formData.document];
            form.loading = false;
            scope.$digest();
            return defer.promise;
        }

        OnBoardingAPI.getUnifiedRightToWorkLatestCase(formData.documentData.brand_id, formData.documentData.candidate_id, OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT)
            .then(function (data) {
                form.document = data;
                form.loading = false;
                scope.$digest();
            });

        return defer.promise;
    };

    form.send = function () {
        var documentData = formData.documentData;

        if (form.validator.validate()) {
            form.sending = true;

            if (form.resend && !form.isAMSCardSendClicked) {
                let doc = form.document?.[0];
                OnBoardingAPI.documentReminder(
                    doc?.id,
                    OnBoardingAPI.DOC_REMINDER_TYPE.CORRECTION,
                    (form.data.message || defaultMessage)
                ).then(function (data) {

                    hAlert($filter("translate")("Thanks!"),
                        $filter("translate")("A reminder message has been sent for the employee to correct their information"));

                    doc.state = OnBoardingAPI.appStatuses.REQUESTED;

                    _emitter.trigger("done", documentData, doc);
                    form.sending = false;

                    scope.$digest();
                }, function (res) {

                    hAlert($filter("translate")("Error!"), res.data);

                    console.error("An Error with Doc Action API:", res);
                    form.sending = false;
                    scope.$digest();
                });
            } else {
                let payload = {
                    metadata: {
                        isKeesingEnabled: false
                    },
                    employer_message: form.data.message || defaultMessage,
                    prospect: {
                        user_id: documentData.candidate_id,
                        application_id: documentData.app_id,
                        position_id: documentData.positions?.[0]?.id,
                        job_id: documentData.job_id,
                        id: documentData.prospect_id,
                    }
                }

                OnBoardingAPI.requestNewDocument(documentData.brand_id, documentData.candidate_id, OnBoardingAPI.DOCUMENT_TYPE.IDENTITY_DOCUMENT, payload).then((res) => {
                    form.sending = false;
                    if (res.sent) {
                        _emitter.trigger("done", documentData, res.sent[0]);
                    }
                    scope.$digest();
                }).catch((err) => {
                    form.sending = false;
                    console.error(err);
                    scope.$digest();
                });
            }
        }
    };
};
